export const SET_AUTHENTICATE = 'SET_AUTHENTICATE';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const LOADING = 'LOADING';

export default {
  SET_AUTHENTICATE,
  SET_PROFILE,
  SET_LANGUAGE,
  LOADING,
};
